import { darkTheme, lightTheme, type Theme } from '@rainbow-me/rainbowkit'

/** Acento alineado con tokens Deep Space (`--primary` en `.dark`). */
const ACCENT = '#00e8a3'
const ACCENT_FOREGROUND = '#0a0a12'

const sharedOptions = {
  accentColor: ACCENT,
  accentColorForeground: ACCENT_FOREGROUND,
  borderRadius: 'medium' as const,
  fontStack: 'system' as const,
  overlayBlur: 'small' as const,
}

export function buildRainbowKitTheme(darkMode: boolean): Theme {
  return darkMode ? darkTheme(sharedOptions) : lightTheme(sharedOptions)
}
